import React, { Component } from 'react';
import { Box, Text, Flex } from '@spothero/ui';
import ErrorUtils from 'utils/error-utils';
export default class ErrorBoundary extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            error: null,
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error,
        };
    }
    componentDidCatch(error) {
        ErrorUtils.sendSentryException(error);
    }
    render() {
        const { children } = this.props;
        const { error } = this.state;
        if (error) {
            return (<Box width="100%" height="100%" color="navy.900">
                    <Flex direction="column" alignItems="center" justifyContent="center" textAlign="center" paddingTop="4">
                        <Text fontSize="lg" paddingBottom="2">
                            An error has occurred.
                        </Text>
                        <Text fontSize="lg" paddingBottom="2">
                            Please refresh the page and try again.
                        </Text>
                    </Flex>
                </Box>);
        }
        return children;
    }
}
